module.exports = __webpack_public_path__ + "img/webinar-fan.0ab13241.png";